var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.types[_vm.input.type],_vm._g(_vm._b({tag:"component",model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}},'component',{..._vm.$props, ..._vm.$attrs},false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }